import Icon from "components/icon";
import { Link } from "react-router-dom";
import React from "react";
import { UP_RIGHT } from "icons";
import { useJob } from "../context";

const MilestoneCreationBanner = () => {
  const  { milestoneJobCount } = useJob(); 
  if(milestoneJobCount !== 0) return null;
  return (
    <aside
      role="banner"
      aria-label="Milestone Creation announcement"
      // className="fixed top-16 left-0 right-0 mx-auto px-6"
      className="px-6"
    >
      <div className="flex items-center bg-blue-50 pl-4 pr-6 py-3 md:py-4 relative rounded-xl  mx-auto">
        <Link
          to="./milestones"
          className="flex items-center justify-start gap-2 w-full cursor-pointer"
          aria-label="Learn more about shadcn/ui kit Pro blocks"
        >
          <span className="text-sm text-blue-800">
            <span className="font-semibold">Note</span> · A milestone is required to log hours in the timesheet.
          </span>
        </Link>
        <Link
          className="absolute right-2 w-8 h-8 flex items-center justify-center rounded-md hover:bg-white/10"
          aria-label="Close announcement"
          to="./milestones"
        >
          <Icon className="size-4" aria-hidden="true" icon={UP_RIGHT} />
          <span className="sr-only">GoTo Milestones</span>
        </Link>
      </div>
    </aside>
  );
};

export default MilestoneCreationBanner;
